import { useEffect } from "react"
import { useTranslation } from "react-i18next"
import { fspConfig } from "./init/fsp-config"

//! We decided to ignore some meta tags for now because we believe they will be easier to work with
// once we've upgraded to React 19.
// The problem we were running into is that the meta tags are generated both server side during
// build time and client side when the app runs and we were getting hydration mismatches.
// In particular, it's difficult to know server-side which language to choose.
// We must also know whether we're dealing with the maul web app or the Tiffin web app.
export function meta() {
  const func = "meta"

  const metaTagsBasics = [
    {
      charSet: "utf-8",
    },
    {
      name: "viewport",
      content: "width=device-width,initial-scale=1",
    },
  ]

  return metaTagsBasics
}

//! We will have a look at this again when we reintroduce meta tags.
//! Not being used at the time of writing.
/**
 * Custom hook to dynamically update document meta tags after translations are loaded
 * This runs only on the client side after hydration
 */
export function useDynamicMeta() {
  const { t, ready } = useTranslation()
  const { fspId } = fspConfig

  useEffect(() => {
    if (!ready || typeof document === "undefined") return

    const translatedTitle = t("helmet.title", { ns: fspId })
    const translatedDescription = t("helmet.meta", { ns: fspId })

    document.title = translatedTitle

    const metaDescription = document.querySelector('meta[name="description"]')
    if (metaDescription) {
      metaDescription.setAttribute("content", translatedDescription)
    }

    const ogTitle = document.querySelector('meta[property="og:title"]')
    if (ogTitle) {
      ogTitle.setAttribute("content", translatedTitle)
    }

    const ogDescription = document.querySelector('meta[property="og:description"]')
    if (ogDescription) {
      ogDescription.setAttribute("content", translatedDescription)
    }

    const twitterTitle = document.querySelector('meta[name="twitter:title"]')
    if (twitterTitle) {
      twitterTitle.setAttribute("content", translatedTitle)
    }

    const twitterDescription = document.querySelector('meta[name="twitter:description"]')
    if (twitterDescription) {
      twitterDescription.setAttribute("content", translatedDescription)
    }

    console.log("🌐✨ Updated meta tags with translations:", {
      title: translatedTitle,
      description: translatedDescription,
    })
  }, [ready, t, fspId])
}
